var React = require('react');
var PropTypes = React.PropTypes;
import RaisedButton from 'material-ui/RaisedButton';
var moment = require('moment');
var ReviewTaskRes = require('../../../resources/review_task');

var CollectionCommentList = React.createClass({

  retrieveCollectionMessages: function(callback) {
    callback = callback || function(){};
    var query = {
      include: "message",
      conditions: JSON.stringify({
        type: "COLLECTION_REVIEW",
        content: this.state.reviewTaskData.contentInfo._id
      })
    }
    var options = {query: query};
    ReviewTaskRes.retrieveSingleReviewTask(options, function(err, res) {
      return callback(err, res);
    })
  },

  buildInitialCollectionMessagesData: function() {
    var reviewTaskData = this.state.reviewTaskData;
    if (!reviewTaskData.collectionMessages) reviewTaskData.collectionMessages = [];
    if (!reviewTaskData.contentInfo.messages || reviewTaskData.contentInfo.messages.length <= 0) return;
    for (var i = 0; i < reviewTaskData.contentInfo.messages.length; i++) {
      var message = reviewTaskData.contentInfo.messages[i],
          roundIndex = (message.metadata.reviewRound && message.metadata.reviewRound > 0)
          ? message.metadata.reviewRound - 1 : 0;
      if (!reviewTaskData.collectionMessages[roundIndex]) reviewTaskData.collectionMessages[roundIndex] = [];
      reviewTaskData.collectionMessages[roundIndex].push(message);
    }
    this.setState({reviewTaskData: reviewTaskData});
  },

  buildCollectionMessagesData: function(messagesData, callback) {
    callback = callback || function(){};
    var collectionMessages = [];
    for (var i in messagesData) {
      var roundIndex = (messagesData[i].reviewRound - 1) > 0 ? messagesData[i].reviewRound - 1 : 0;
      if (!collectionMessages[roundIndex]) collectionMessages[roundIndex] = [];
      if (messagesData[i].messages && messagesData[i].messages.length > 0) {
        collectionMessages[roundIndex] = collectionMessages[roundIndex].concat(messagesData[i].messages);
      }
    }
    for (var j in collectionMessages) {
      if (!collectionMessages[j]) break;
      collectionMessages[j].sort(function(a,b) {
        return b.dateModified - a.dateModified;
      })
    }
    var reviewTaskData = this.state.reviewTaskData;
    for (var ij = 0; ij < collectionMessages.length; ij++) {
      if (!reviewTaskData.collectionMessages[ij]) reviewTaskData.collectionMessages[ij] = [];
      if (!collectionMessages[ij]) collectionMessages[ij] = [];
      reviewTaskData.collectionMessages[ij] = reviewTaskData.collectionMessages[ij].concat(collectionMessages[ij]);
    }
    // for (var k = 0; k < collectionMessages.length; k++) {
    //   if (!collectionMessages[k]) collectionMessages[k] = [];
    // }
    return callback(reviewTaskData);
  },

  submitCollectionMessage: function() {
    var _this = this;
    // var round = (this.state.reviewTaskData.reviewRound - 1) > 0 ? this.state.reviewTaskData.reviewRound - 1 : 0;
    var roundIndex = this.state.reviewTaskData.contentInfo.current_review_round - 1;
    var mode = this.props.taskMode;
    var options = {};
    var text = this.refs.collectionMessage.value;
    if (!text.replace(/ /g, '')) return;
    if (mode === 'review') {
      options = {
        reviewTask: this.state.reviewTaskData._id,
        text: this.refs.collectionMessage.value
      }
    } else if (mode === 'revise' || mode === 'admin-view') {
      options = {
        type: "COLLECTION_MESSAGE",
        text: this.refs.collectionMessage.value,
        content: this.state.reviewTaskData.contentInfo._id,
        metadata: {
          reviewRound: roundIndex + 1
          // reviewRound: round
        }
      }
    }
    ReviewTaskRes.submitMessage(options, function(err, res) {
      if (!_this.state.reviewTaskData.collectionMessages[roundIndex])
        _this.state.reviewTaskData.collectionMessages[roundIndex] = [];
      _this.state.reviewTaskData.collectionMessages[roundIndex].push(res);
      _this.refs.collectionMessage.value = "";
      _this.setState({
        reviewTaskData: _this.state.reviewTaskData
      });
    })
  },

  getInitialState: function() {
    return {
       reviewTaskData: this.props.reviewTaskData
    };
  },

  componentWillMount: function() {

  },

  componentWillReceiveProps: function(nextProps) {
    this.setState({
      reviewTaskData: nextProps.reviewTaskData ? nextProps.reviewTaskData : this.state.reviewTaskData
    })
  },

  render: function() {
    var _this = this,
        mode = this.props.taskMode,
        commentableMode = (mode === 'review') || (mode === 'revise') || (mode === 'admin-view');
    return (
      <div className="comment-collection">
        <h3>Comments</h3>
        <div className="review-round">
          {
            _this.state.reviewTaskData.collectionMessages && _this.state.reviewTaskData.collectionMessages.length > 0 && (
              _this.state.reviewTaskData.collectionMessages.map(function(messageByRound, round) {
                return (
                  <div key={round}>
                    <div className="round-title">{"Round " + (round+1)}</div>
                    {
                      (!messageByRound || messageByRound.length <= 0) && (
                        <p className="text-muted" style={{fontSize: "12px"}}>{"There is no comment for round " + (round+1)}</p>
                      )
                    }
                    {
                      messageByRound && messageByRound.length > 0 && messageByRound.map(function(comment, index) {
                        if (comment.type === 'TASK_MESSAGE' || comment.type === 'COLLECTION_MESSAGE') {
                          return(
                            <div className="comment" key={index}>
                              <div className="comment-title">
                                <div className="main">{comment.creatorName}</div>
                                <div className="sub">{moment(comment.dateModified).format('DD MMM, YYYY - hh:mm A')}</div>
                              </div>
                              <div className="comment-content">
                                <p>{comment.text}</p>
                              </div>
                            </div>
                          )
                        }
                      })
                    }
                  </div>
                )
              })
            )
          }
        </div>
        {
          commentableMode && (
            <div>
              <textarea className="form-control" placeholder="Write a comment for the collection" ref="collectionMessage" style={{marginBottom: "10px"}}></textarea>
              <RaisedButton primary={true} label="Comments for whole collection" onClick={_this.submitCollectionMessage}/>
            </div>
          )
        }
      </div>
    );
  },

  componentDidMount: function() {
    var _this = this;
    this.buildInitialCollectionMessagesData();
    this.retrieveCollectionMessages(function(err, res) {
      if (!err && res) _this.buildCollectionMessagesData(res, function(reviewTaskData) {
        _this.setState({reviewTaskData: reviewTaskData})
      })
    })
  }

});

export default CollectionCommentList;



/** WEBPACK FOOTER **
 ** ./src/components/Tasks/Review/CollectionCommentList.js
 **/